export const PageHeader = ({ eyebrow, title, desc, children }) => (
  <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8 fade-up">
    <div>
      {eyebrow && <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#E07A5F]">{eyebrow}</p>}
      <h1 className="mt-2 text-3xl md:text-4xl font-semibold tracking-tight" data-testid="page-title">{title}</h1>
      {desc && <p className="mt-2 text-slate-600 max-w-2xl leading-relaxed">{desc}</p>}
    </div>
    {children && <div className="flex gap-2 flex-wrap">{children}</div>}
  </div>
);
